import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import { installSupportSessionBridge } from './utils/support_session';
import filters from './filters/index';
import titleMixin from './mixin/title_mixin';
import calendarDisplayMixin from './mixin/calendar_display_mixin';
import ToastPlugin from 'vue-toast-notification';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import 'primeicons/primeicons.css';
import 'vue-toast-notification/dist/theme-bootstrap.css';
import VueAwesomePaginate from 'vue-awesome-paginate';
import 'vue-awesome-paginate/dist/style.css';
import GoogleSignInPlugin from "vue3-google-signin"
import { registerServiceWorker } from './pwa/registerServiceWorker';
import { initSentry } from './utils/sentry';
import AppDateInput from '@/components/App_Date_Input.vue';
import KodeAiButton from '@/components/kode_ai/Kode_AI_Button.vue';

const app = createApp(App);
app.mixin(titleMixin);
app.mixin(calendarDisplayMixin);

app.component('FontAwesomeIcon', FontAwesomeIcon);
app.component('AppDateInput', AppDateInput);
// Kode AI's button, which every page's top bar carries (components/kode_ai).
app.component('KodeAiButton', KodeAiButton);

const gauthOption = {
  clientId: process.env.VUE_APP_GOOGLE_OAUTH_CLIENT_ID
}

// Before mount, so errors thrown while mounting are reported too.
initSentry(app, store);

app
  // .use(posthogPlugin)
  .use(VueAwesomePaginate)
  .use(GoogleSignInPlugin, gauthOption)
  .use(ToastPlugin)
  .use(store)
  .use(router)
  .mount('#app');

app.config.globalProperties.$filters = filters;

// Make the app installable as a PWA (production builds only).
registerServiceWorker();

// Screenkode staff inside this app through a support session launched from
// the admin (utils/support_session): what the admin tells the app to do, and
// which page the app is on.
installSupportSessionBridge(store, router);
